import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
// import App from './App2';
import reportWebVitals from './reportWebVitals';

import 'tailwindcss/tailwind.css';
import 'antd/dist/antd.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'react-reflex/styles.css';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
